export default "__VITE_ASSET__DH7SD0$m__"